/**
 * Generated by orval 🍺
 * Do not edit manually.
 * FastAPI
 * OpenAPI spec version: 0.1.0
 */
import type { GenericApiResponseListTaskData } from './genericApiResponseListTaskData';
import type { GenericApiResponseListTaskMessage } from './genericApiResponseListTaskMessage';
import type { GenericApiResponseListTaskPagination } from './genericApiResponseListTaskPagination';
import type { GenericApiResponseListTaskError } from './genericApiResponseListTaskError';

export interface GenericApiResponseListTask {
  data?: GenericApiResponseListTaskData;
  message?: GenericApiResponseListTaskMessage;
  pagination?: GenericApiResponseListTaskPagination;
  error?: GenericApiResponseListTaskError;
  statusCode?: number;
}
